import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { useSwrFetcherWithAccessToken } from "@/functions/useSwrFetcherWithAccessToken";
import useSWR from "swr";
import { IVacancyDetail, ListOfVacancy, VacancyList } from "./interfaces/VacancyInterface";


export function GetVacancyDetail(id: string | undefined){
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data } = useSWR<IVacancyDetail>(
        `${BackendApiUrl.getVacancyDetail}?id=${id}`,
        swrFetcher
    );
    return data;
}

export function GetVacancyList(){
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data: vacancies } = useSWR<VacancyList>(
        `${BackendApiUrl.getVacanciesList}`,
        swrFetcher
    );
    return vacancies;
}

export function GetVacanciesList(id: string | undefined){
    const { data } = useSWR<ListOfVacancy>(
        `${BackendApiUrl.getVacanciesList}?UserId=${id}`, 
        useSwrFetcherWithAccessToken()
    )
    return data;
}